/* tslint:disable */
/* eslint-disable */
/**
 * 160 Digital OS API
 * RESTful API for 160 Digital Operating System
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: it@160driving.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AssessmentAnswerDto } from './assessment-answer-dto';

/**
 * 
 * @export
 * @interface EnrollmentAssessmentDto
 */
export interface EnrollmentAssessmentDto {
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'enrollmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentAssessmentDto
     */
    'testName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentAssessmentDto
     */
    'status'?: EnrollmentAssessmentDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'attemptNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'totalQuestions'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'correctAnswers'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'passingScore'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentAssessmentDto
     */
    'passed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'timeLimitMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnrollmentAssessmentDto
     */
    'timeSpentSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentAssessmentDto
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentAssessmentDto
     */
    'completedAt'?: string;
    /**
     * 
     * @type {Array<AssessmentAnswerDto>}
     * @memberof EnrollmentAssessmentDto
     */
    'answers'?: Array<AssessmentAnswerDto>;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentAssessmentDto
     */
    'createdAt'?: string;
}

export const EnrollmentAssessmentDtoStatusEnum = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Passed: 'PASSED',
    Failed: 'FAILED',
    Waived: 'WAIVED'
} as const;

export type EnrollmentAssessmentDtoStatusEnum = typeof EnrollmentAssessmentDtoStatusEnum[keyof typeof EnrollmentAssessmentDtoStatusEnum];


